import { scrollTo } from '../../utils/_scrollTo';

const setupApplePayPaymentPage = () => {
	if($('apple-pay-button').length > 0){
		if(window.ApplePaySession && window.ApplePaySession.canMakePayments() && window.ApplePaySession.canMakePaymentsWithActiveCard()){
			if(Number($('#creditCardForm input[name="piAmount"]').val()) > 0){
				$('apple-pay-button').show();
			}
			$('apple-pay-button').click(onApplePayButtonClicked);
		}
	}
}

const setupApplePayCartPage = () => {
	if($('apple-pay-button').length > 0){
		if(window.ApplePaySession && window.ApplePaySession.canMakePayments() && window.ApplePaySession.canMakePaymentsWithActiveCard()){
			var subscribeChecked = $('input[id^=subFrequencyRadio_subscribe]:checked').length > 0;
			if(!subscribeChecked && Number($('#totalforJS').html().replace(/[^0-9\.]+/g, '')) > 0){
				$('apple-pay-button').show();
			}
			$('apple-pay-button').click(onApplePayButtonClicked);
		}
	}
}
const onApplePayButtonClicked = () => {
    if (!window.ApplePaySession) {
        return;
    }
    
    // Define ApplePayPaymentRequest
    const request = {
        "countryCode": "US",
        "currencyCode": "USD",
        "requiredBillingContactFields": ["name", "postalAddress"],
        "merchantCapabilities": [
            "supports3DS"
        ],
        "supportedNetworks": [
            "visa",
            "masterCard",
            "amex",
            "discover"
        ],
        "total": {
            "label": "Order Total",
            "type": "final",
        }
    };
    
    if($('#ShopCartForm').length > 0){
    	request.requiredShippingContactFields = ["name", "phone", "email", "postalAddress"];
    	request.total.amount = Number($('#totalforJS').html().replace(/[^0-9\.]+/g, ''));
    } else {
    	request.total.amount = $('#creditCardForm input[name="piAmount"]').val();
    }
    
    // Create ApplePaySession
    const session = new ApplePaySession(3, request);
    
    session.onvalidatemerchant = event => {
        // Call your own server to request a new merchant session.
		$.ajax({
			url: '/wcs/resources/store/301/order/payment/applePay/session',
			data:JSON.stringify({"validationURL":event.validationURL}),
			cache: false,
			type: 'POST',
			dataType: 'json',
			contentType: "application/json",
			success: function (json) {
				return session.completeMerchantValidation(json.response);
			}
			,error: function(jqXHR, textStatus, errorThrown){
				handleError('An error occured, please try again or choose a different payment method.', jqXHR.message || JSON.stringify(jqXHR.responseJSON) || undefined);
				session.abort();
			}
		});
    };
    
    session.onpaymentmethodselected = event => {
        // Define ApplePayPaymentMethodUpdate based on the selected payment method.
        // No updates or errors are needed, pass an empty object.
        const update = {};
		var applePayPaymentMethodUpdate = {
			"newTotal": {
				label: "Dillard's", 
				amount: Number($('#creditCardForm input[name="piAmount"], #ShopCartForm input[name="piAmount"]').val())
			},
			"newLineItems": []
		};
        session.completePaymentMethodSelection(applePayPaymentMethodUpdate);
    };
    
    session.onshippingmethodselected = event => {
        // Define ApplePayShippingMethodUpdate based on the selected shipping method.
        // No updates or errors are needed, pass an empty object. 
        const update = {};
        session.completeShippingMethodSelection(update);
    };
    
    session.onshippingcontactselected = event => {
        // Define ApplePayShippingContactUpdate based on the selected shipping contact.
        const update = {};
		var data = {
				"firstName": "Apple"
				,"lastName": "Pay"
				,"address1": "PlaceHolder"
				,"address2": ""
				,"city": event.shippingContact.locality
				,"state": event.shippingContact.administrativeArea
				,"zipCode": event.shippingContact.postalCode.split('-').join('')
				,"nickName": "ApplePayShipping"
				,"orderId": $('#ShopCartForm').children('input[name="orderId"]').val()
			}
		$.ajax({
			url: "/webapp/wcs/stores/servlet/shippingAddressAdd",
			cache: false,
			type: "POST",
	        data: data,
	        async: false, 
			success: function(json) {
				if(json.JSONError){
					handleError('Failed to add your shipping address, please try again.', 'responseJSON: ' + JSON.stringify(json));
					 session.completeShippingContactSelection({
			         	"status": "STATUS_FAILURE",
			         	"newTotal": {
			         		"type": "final",
			         		"label": "Dillard's",
			         		"amount": json.JSON.newOrderTotal.split('$').join('')
			         	}
			         });
				} else{
					var responseJSON = json.JSON;
					if(responseJSON && responseJSON.order && responseJSON.order.defaultShippingMethod){
						var shipMethod = responseJSON.order.defaultShippingMethod;
						if(json.JSON.order && json.JSON.order.orderItems[0] && json.JSON.order.orderItems[0].shippingAddressId){
							var form = $('#ShopCartForm');
							form.children('input[name="billing_address_id"]').remove();
							form.append(`<input name="billing_address_id" type="hidden" value="${json.JSON.order.orderItems[0].shippingAddressId}">`);
							form.children('input[name="editAddressId"]').val(json.JSON.order.orderItems[0].shippingAddressId);
						}
						shippingMethodChange(session, shipMethod, responseJSON.order.orderId);
					} else {
						handleError('Failed to add your shipping address, please try again.', 'responseJSON: ' + JSON.stringify(responseJSON));
					}
				}
			},
			error: function(json) {
				 session.completeShippingContactSelection({
		         	"status": "STATUS_FAILURE",
		         	"newTotal": {
		         		"type": "final",
		         		"label": "Dillard's",
		         		"amount": json.JSON.newOrderTotal.split('$').join('')
		         	}
		         });
				handleError('To continue checkout with ApplePay, please confirm your billing address is correct and try again.', 'Error response from ApplePay-' + JSON.stringify(json));
			}
		});
    };
    
    session.onpaymentauthorized = event => {
        // Define ApplePayPaymentAuthorizationResult
		const patternForZip = "[0-9]";
		if (
			(event.payment.billingContact.givenName != undefined && event.payment.billingContact.givenName.length > 15) 
		) {
			handleError(
				'Your Apple Pay billing first name cannot exceed fifteen (15) characters. To continue checkout with Apple Pay, please correct your Apple Pay billing first name and try again.'
			);
			const result = { status: ApplePaySession.STATUS_FAILURE };
			session.completePayment(result);
		
		} 

		else if (
			(event.payment.billingContact.familyName != undefined && event.payment.billingContact.familyName.length > 25) 
		) {
			handleError(
				'Your Apple Pay billing last name cannot exceed twenty-five (25) characters. To continue checkout with Apple Pay, please correct your Apple Pay billing last name and try again.'
			);
			const result = { status: ApplePaySession.STATUS_FAILURE };
			session.completePayment(result);
		
		} 

		else if (
			(event.payment.billingContact.addressLines[0] != undefined && event.payment.billingContact.addressLines[0].length > 30) ||
			(event.payment.billingContact.addressLines[1] != undefined && event.payment.billingContact.addressLines[1].length > 30)
		) {
			handleError(
				'Your Apple Pay billing street address cannot exceed thirty (30) characters. To continue checkout with Apple Pay, please correct your Apple Pay billing street address and try again.'
			);
			const result = { status: ApplePaySession.STATUS_FAILURE };
			session.completePayment(result);
		
		} 

		else if (
			(event.payment.billingContact.locality != undefined && event.payment.billingContact.locality.length > 20) 
		) {
			handleError(
				'Your Apple Pay billing city cannot exceed twenty (20) characters. To continue checkout with Apple Pay, please correct your Apple Pay billing city and try again.'
			);
			const result = { status: ApplePaySession.STATUS_FAILURE };
			session.completePayment(result);
		
		} 
		
		else if (
			
			(event.payment.billingContact.postalCode != undefined && event.payment.billingContact.postalCode.search(patternForZip) == -1) 
		) {
			handleError(
				'Your Apple Pay billing zip code cannot exceed nine (9) characters or contain non-numeric characters. To continue checkout with Apple Pay, please correct your Apple Pay billing zip code and try again.'
			);
			const result = { status: ApplePaySession.STATUS_FAILURE };
			session.completePayment(result);
		
		}
				
		else {
			const result = {
				status: ApplePaySession.STATUS_SUCCESS,
			};
			if ($('#orderReviewForm').length > 0 && $('#creditCardForm').length > 0) {
				var orderReviewForm = $('#orderReviewForm');
				appendApplePayInfoToForm(orderReviewForm);
				appendBillingInfoToForm(orderReviewForm);
				const amount = $('#creditCardForm input[name="piAmount"]').val();
				$(`<input type="hidden" name="applePayAmount" value="${amount}" />`).appendTo(orderReviewForm);
				$(`<input type="hidden" name="isApplePay" value="true" />`).appendTo(orderReviewForm);
				$('input[name="CardType2"]').attr('checked', false);
				$('#applepay').attr('checked', true);
				session.completePayment(result);
				$('#creditCardForm').submit();
			} else {
				var shoppingCartForm = $('#ShopCartForm');
				appendApplePayInfoToForm(shoppingCartForm);
				appendBillingInfoToForm(shoppingCartForm);
				appendShippingInfoToForm(shoppingCartForm);
				var amount = Number(
					$('#totalforJS')
						.html()
						.replace(/[^0-9\.]+/g, '')
				);
				shoppingCartForm.find('input[name="piAmount"]').remove();
				$(`<input type="hidden" name="piAmount" value="${amount}" />`).appendTo(shoppingCartForm);
				shoppingCartForm.children('input[name="URL"]').val('OrderReviewCmd');
				shoppingCartForm.prop('action', 'ApplePayExpressCheckout');
				session.completePayment(result);
				shoppingCartForm.submit();
			}
		}
    };
    
    session.oncancel = event => {
        // Payment cancelled by WebKit
    };
    
    session.begin();
};

const appendApplePayInfoToForm = (form) => {
	$(`<input type="hidden" name="appleBundleData" value="${event.payment.token.paymentData.data}" />`).appendTo(form);
	$(`<input type="hidden" name="appleBundleSignature" value="${event.payment.token.paymentData.signature}" />`).appendTo(form);
	$(`<input type="hidden" name="appleBundleVersion" value="${event.payment.token.paymentData.version}" />`).appendTo(form);
	$(`<input type="hidden" name="appleBundleHeaderPublicKeyHash" value="${event.payment.token.paymentData.header.publicKeyHash}" />`).appendTo(form);
	$(`<input type="hidden" name="appleBundleHeaderEphemeralPublicKey" value="${event.payment.token.paymentData.header.ephemeralPublicKey}" />`).appendTo(form);
	$(`<input type="hidden" name="appleBundleHeaderTransactionId" value="${event.payment.token.paymentData.header.transactionId}" />`).appendTo(form);
};

const appendBillingInfoToForm = (form) => {
	var billingState = event.payment.billingContact.administrativeArea;
	if(event.payment.billingContact.administrativeArea.length > 2){
		var stateCodes = {
			"alabama": {"code": "AL"},"alaska": {"code": "AK"},"american Samoa": {"code": "AS"},"arizona": {"code": "AZ"},"arkansas": {"code": "AR"},"california": {"code": "CA"},
			"colorado": {"code": "CO"},"connecticut": {"code": "CT"},"delaware": {"code": "DE"},"florida": {"code": "FL"},"georgia": {"code": "GA"},"hawaii": {"code": "HI"},"idaho": {"code": "ID"},
			"illinois": {"code": "IL"},"indiana": {"code": "IN"},"iowa": {"code": "IA"},"kansas": {"code": "KS"},"kentucky": {"code": "KY"},"louisiana": {"code": "LA"},"maine": {"code": "ME"},
			"maryland": {"code": "MD"},"massachusetts": {"code": "MA"},"michigan": {"code": "MI"},"minnesota": {"code": "MN"},"mississippi": {"code": "MS"},"missouri": {"code": "MO"},
			"montana": {"code": "MT"},"nebraska": {"code": "NE"},"nevada": {"code": "NV"},"newhampshire": {"code": "NH"},"newjersey": {"code": "NJ"},"newmexico": {"code": "NM"},
			"newyork": {"code": "NY"},"northcarolina": {"code": "NC"},"northdakota": {"code": "ND"},"ohio": {"code": "OH"},"oklahoma": {"code": "OK"},"oregon": {"code": "OR"},
			"pennsylvania": {"code": "PA"},"rhodeisland": {"code": "RI"},"southcarolina": {"code": "SC"},"southdakota": {"code": "SD"},"tennessee": {"code": "TN"},"texas": {"code": "TX"},
			"utah": {"code": "UT"},"vermont": {"code": "VT"},"virginia": {"code": "VA"},"washington": {"code": "WA"},"westvirginia": {"code": "WV"},"wisconsin": {"code": "WI"},"wyoming": {"code": "WY"}
		};
		var toCheck = event.payment.billingContact.administrativeArea.split(' ').join('').toLowerCase();
		if(stateCodes[toCheck]){
			billingState = stateCodes[toCheck].code
		}
	}
	$(`<input type="hidden" name="billingFirstName" value="${event.payment.billingContact.givenName}" />`).appendTo(form);
	$(`<input type="hidden" name="billingLastName" value="${event.payment.billingContact.familyName}" />`).appendTo(form);
	$(`<input type="hidden" name="billingAddress1" value="${event.payment.billingContact.addressLines.length > 0? event.payment.billingContact.addressLines[0]: ''}" />`).appendTo(form);
	$(`<input type="hidden" name="billingAddress2" value="${event.payment.billingContact.addressLines.length > 1? event.payment.billingContact.addressLines[1]: ''}" />`).appendTo(form);
	$(`<input type="hidden" name="billingCity" value="${event.payment.billingContact.locality}" />`).appendTo(form);
	$(`<input type="hidden" name="billingState" value="${billingState}" />`).appendTo(form);
	$(`<input type="hidden" name="billingZip" value="${event.payment.billingContact.postalCode.split('-').join('')}" />`).appendTo(form);
};

const appendShippingInfoToForm = (form) => {
	$(form).find("input[name='email']").remove();
	$(`<input type="hidden" name="email" value="${event.payment.shippingContact.emailAddress}" />`).appendTo(form);
	$(form).find("input[name='phone']").remove();
	$(`<input type="hidden" name="phone" value="${event.payment.shippingContact.phoneNumber}" />`).appendTo(form);
	$(`<input type="hidden" name="shippingFirstName" value="${event.payment.shippingContact.givenName}" />`).appendTo(form);
	$(`<input type="hidden" name="shippingLastName" value="${event.payment.shippingContact.familyName}" />`).appendTo(form);
	$(`<input type="hidden" name="shippingAddress1" value="${event.payment.shippingContact.addressLines.length > 0? event.payment.shippingContact.addressLines[0]: ''}" />`).appendTo(form);
	$(`<input type="hidden" name="shippingAddress2" value="${event.payment.shippingContact.addressLines.length > 1? event.payment.shippingContact.addressLines[1]: ''}" />`).appendTo(form);
	$(`<input type="hidden" name="shippingCity" value="${event.payment.shippingContact.locality}" />`).appendTo(form);
	$(`<input type="hidden" name="shippingState" value="${event.payment.shippingContact.administrativeArea}" />`).appendTo(form);
	$(`<input type="hidden" name="shippingZip" value="${event.payment.shippingContact.postalCode.split('-').join('')}" />`).appendTo(form);
};

const shippingMethodChange = (session, shipMethod, orderId) => {
//	var session2 = session;
	$.ajax({
		url: "/webapp/wcs/stores/servlet/ShipModeUpdate",
		cache: false,
		type: "POST",
        data: {"globalShippingMode": shipMethod.id, "massUpdateShipMode":"Y", "orderId": orderId},
        async: false, 
		success: function(json) {
			if(json.JSONError){
				session.completeShippingContactSelection({
		        	"status": "STATUS_FAILURE",
		        	"newTotal": {
		        		"type": "final",
		        		"label": "Dillard's",
		        		"amount": json.JSON.newOrderTotal.split('$').join('')
		        	}
		        });
				handleError('An error occured updating your shipping method. Please try ApplePay again or continue to checkout.', 'Error response from ShipModeUpdate-' + JSON.stringify(json));
			} else{
				var form = $('#ShopCartForm');
				form.find('input[name="piAmount"]').remove()
				form.append(`<input name="piAmount" type="hidden" value="${json.JSON.newOrderTotal.split('$').join('')}">`);
				session.completeShippingContactSelection({
		        	"status": "STATUS_SUCCESS",
		        	"newTotal": {
		        		"type": "final",
		        		"label": "Dillard's",
		        		"amount": json.JSON.newOrderTotal.split('$').join('')
		        	}
		        });

			}
		},
		error: function(json) {
			 session.completeShippingContactSelection({
	         	"status": "STATUS_FAILURE",
	         	"newTotal": {
	         		"type": "final",
	         		"label": "Dillard's",
	         		"amount": json.JSON.newOrderTotal.split('$').join('')
	         	}
	         });
			handleError('To continue checkout with ApplePay, please confirm your billing address is correct and try again.', 'Error response from ApplePay-' + JSON.stringify(json));
		}
	});
};

const handleError = (errorMessage, trackingMessage) => {
	if(errorMessage){
		$('#errors').remove();
		var errorContent = `<div id="errors" class="alert alert-danger alert-dismissible" role="alert">
							<button id="error-message" class="alert-dismiss close" type="button" data-dismiss="alert" aria-label="close" aria-label="close">&times;</button>
							${errorMessage}</div>`;
		$('#step2Content, #cartWrapper').prepend(errorContent);
		if(Dillards.validateThisForm && $('#shippingAddressForm button').length > 0){
			Dillards.validateThisForm($('#shippingAddressForm'));
			$('#shippingAddressForm button').eq(0).click();		
		}
		scrollTo('#step2Content');
	}
	if(trackingMessage){
		$('#applepay-error-tracking').remove();
		var newHTML = `<div class="hidden" id="applepay-error-tracking">${trackingMessage}</div>`;
		$('#content-wrapper').append(newHTML);
	}
};
	
export {setupApplePayPaymentPage, setupApplePayCartPage};
